import { connectAppStore } from "../../../Store/AppStore";
import PageDependencies from "../../../Feature/PageDependencies";

const ImportProject = (props) => {
    const { 
        Fragment,
        useEffect,
        useState,
        layoutManager,
        useReducerSmart,
        BaseForm,
        BindedInput,
        AppLoading,
    } = PageDependencies();
    const debug = layoutManager.Layout_GetDebugModel(props);
    const [init, setInit] = useState(false);
    const [reloadForm, setReloadForm] = useState("");
  
    const [viewModel, dispatchViewModel, bindingViewModel] = useReducerSmart({csvDataBase64: "", filePath: ""});
    const [loading, setLoading] = useState({ isLoading: false, text: "" });

    useEffect(()=>{
        layoutManager.Layout_Headter_Footer_HideSideBar(props);
    },[]);

    useEffect(()=>{
        if(viewModel.filePath !== undefined && viewModel.filePath !== ""){
            const input = document.getElementById("formFile");
            const fReader = new FileReader();
            fReader.readAsDataURL(input.files[0]);
            fReader.onloadend = function(event){
                const file = event.target.result;
                dispatchViewModel({...viewModel, base64Data: file});
            }
        }    
    },[viewModel.filePath]);

    const diableButton = ()=>{
        let d = false;
        if(viewModel.base64Data === undefined){
            d = true;
        }else{
            d = viewModel.base64Data.length == 0;
        }
        return d;
    }

    return (
        <Fragment>
            {debug && <p>{JSON.stringify(viewModel)}</p>}
            {loading.isLoading && (<AppLoading active><div>{loading.text}</div></AppLoading>)}
            <BaseForm
                id="ImportProjectForm"
                icon="pe-7s-info"
                loading={loading}
                setReload={setReloadForm}
                setLoading={setLoading}
                submitButtons = {[
                    {id: "ImportProject", text:"Import Project", postUrl: "api/Project/Accessor/ImportProject", redirectUrl: "/DevelopmentAssessor", disabled: diableButton }             
                ]}
                cancelButton={{ redirectUrl: "/DevelopmentAssessor" }}
                data={viewModel}
                title = "Import project by file"
                subTitle={"Import project"}
            >
                <div className="form-row row">              
                    <div className="col-6">
                        <div className="position-relative form-group">
                            <label htmlFor="ProjectName">Project name (optional)</label>
                            <BindedInput
                                className="form-control"
                                binding={[viewModel, "projectName", bindingViewModel]}
                                id="ProjectName"
                                name="ProjectName"
                                type="text"
                            ></BindedInput>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className="position-relative form-group">
                            <label htmlFor="ProjectName">Development name (optional)</label>
                            <BindedInput
                                className="form-control"
                                binding={[viewModel, "developmentName", bindingViewModel]}
                                id="DevelopmentName"
                                name="DevelopmentName"
                                type="text"
                            ></BindedInput>
                        </div>
                    </div>
                    <div className="col-6">          
                        <div className="mb-3">
                            <label htmlFor="formFile" className="form-label">Upload project file</label>
                            <BindedInput  type="file" id="formFile" accept=".are, .xml" className="form-control" binding={[viewModel, "filePath", bindingViewModel]}></BindedInput>    
                        </div>
                    </div>
                </div>
            </BaseForm>
        </Fragment>
    );
}
export default connectAppStore(ImportProject);